import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Controllers } from '@shared/core/controllers';
import * as Services from '@shared/core/services';

import { ModalViewComponent } from '../modal-view.shared.component';
import * as actions from '@shared/state/onlineOrder/online-order.actions';
import { Store } from '@ngrx/store';
import { IStateShared } from '@shared/state';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'shared-modal-for-add-voucher',
    templateUrl: './modal-for-add-voucher.shared.component.html',
    styleUrls: ['./modal-for-add-voucher.shared.component.scss']
})
export class ModalForAddVoucherComponent extends ModalViewComponent implements OnInit {
    private _form!: FormGroup;
    private _voucherCode!: string;
    private _title: string = 'Enter promotion code';
    private _preTitle: string = 'PROMOTIONS';
    private _description: string[] = ['Enter your promotional code to apply discount to your order'];
    public voucherLoading$: Observable<string>;

    constructor(
        public modalsService: Services.ModalsService,
        public heightAdjustService: Services.HeightAdjustService,
        public controllers: Controllers,
        private _store: Store<IStateShared>,
    ) {
        super(modalsService, heightAdjustService, null);
    }

    ngOnInit(): void {
        this.size = 'sm';
        this.voucherLoading$ = this.controllers.onlineOrders.isVoucherLoading$();
    }

    public handleFormInit($event: FormGroup): void {
        this._form = $event;

        setTimeout(() => {
            this.handleHeightUpdate();
        }, 50);
    }

    public handleAddVoucherClick(): void {
        if (this._form) {
            this._voucherCode = this._form.get('voucherCode').value;
        }

        this.controllers.onlineOrders.addVoucherToOrder(this._voucherCode, this.modalData.id);
    }

    public get isFormValid(): boolean {
        return this._form?.valid === true;
    }

    public get title(): string {
        return this._title;
    }

    public get preTitle(): string {
        return this._preTitle;
    }

    public get description(): string[] {
        return this._description;
    }

    public close(): void {
        this._store.dispatch(actions.OnlineOrderVoucherErrorReset());
        this.modalsService.close(this.modalData.id);
    }

    public handleCloseClick($event: OLO.Components.Modals.ICloseEvent): void {
        this.close();
    }
}
